import { ScheduleCreateProps, ShiftCreateProps } from "../interface/schedule";
import { getRequestConfiguration } from "../utils/headerHelper";
import Axios from "../utils/http-request";
import { AxiosErrorResponse } from "../interface/api_request";

export const apiCreateSchedule = async (fieldValues: ScheduleCreateProps) => {
  const formData = new URLSearchParams();
  // Append all form fields to FormData
  Object.entries(fieldValues).forEach(([key, value]) => {
    if (value !== undefined) {
      formData.append(key, value.toString());
    }
  });
  try {
    const uri = `/schedules/schedule`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.post(uri, formData, cfg);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiCreateShift = async (fieldValues: ShiftCreateProps) => {
  const formData = new URLSearchParams();
  // Append all form fields to FormData
  Object.entries(fieldValues).forEach(([key, value]) => {
    if (value !== undefined) {
      formData.append(key, value.toString());
    }
  });
  try {
    const uri = `/schedules/shift`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.post(uri, formData, cfg);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiGetFacilitySchedules = async (token: string) => {
  const cfg = await getRequestConfiguration({
    "Content-Type": "application/x-www-form-urlencoded",
  });
  try {
    const uri = `/schedules/facility`;
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetScheduleById = async (values: { scheduleId: string }) => {
  try {
    const uri = `/schedules/schedule/${values.scheduleId}`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiDeleteShift = async (values: { shift_id: string }) => {
  try {
    const uri = `/schedules/shift/${values.shift_id}`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.delete(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiDeleteShedule = async (values: { schedule_id: string }) => {
  try {
    const uri = `/schedules/schedule/${values.schedule_id}`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.delete(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiScheduleInterview = async (fieldValues: {
  id: string;
  location: string;
  interview_date: string;
  details: string;
}) => {
  const formData = new URLSearchParams();
  // Append all form fields to FormData
  Object.entries(fieldValues).forEach(([key, value]) => {
    if (value !== undefined) {
      formData.append(key, value.toString());
    }
  });
  try {
    const uri = `/applications/schedule/${fieldValues.id}/interview`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.put(uri, formData, cfg);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};
